import React, { useEffect, useState } from 'react';
import { Mask } from 'antd-mobile';
import friendrst from '../../static/media/friendrst.png';
// import entp from '../../static/media/entp.png';
import friendrst2 from '../../static/media/friendrst2.png';
import rlb from '../../static/media/rlb.jpg';
// import FXT from '../../static/media/ydzf.png';
import FHCS from '../../static/media/fhcsjg.png';
import { personalityResult } from './const';

class Ads4Rlb extends React.Component {
  render() {
    return (
      <><h4 style={{ textAlign: 'center', fontWeight: 500 }}>物流地产圈性格类型大揭秘</h4><p>想知道你的圈内好友们<br />都是什么性格类型?<br /><br />且看下期分享<br />长按下方二维码<br />关注瑞莱博公众号不迷路<br /></p><img style={{ marginTop: '15px', marginBottom: '15px', width: '250px' }} src={rlb} alt="" /></>
    )
  }
}

class UserList extends React.Component {
  render() {
    const { type, topFourTypes, friendTestResultListInfoList } = this.props;
    console.log(friendTestResultListInfoList);
    let record = null;
    const peopelList = [];
    const resultMap = {};
    personalityResult.map((item) => {
      if (item.type === topFourTypes) {
        record = item;
      }
      resultMap[item.type] = item.nickname;
    });
    friendTestResultListInfoList.map((item) => {
      if (record && record[type][item.testResult]) {
        peopelList.push({
          label: record[type][item.testResult],
          ...item,
        })
      }
    })
    if (peopelList.length > 0) {
      return (
        <>
          {
            peopelList.map((item, index) => {
              return <li key={index}>
                <span className='userNicknameTag'>{item.label}</span>
                <img className='userpic' src={item.headPortrait} alt="" />
                <span className='spanStyle' style={{ width: '20%' }}>{item.nickName}</span>
                <img className='userpic' src={require(`../../static/media/${item.testResult}.png`)} alt="" />
                <p className='spanStyle' style={{ margin: 0 }}>{item.testResult} {resultMap[item.testResult]}</p>
              </li>
            })
          }
        </>
      )
    }
    return <span style={{ fontSize: 14 }}>期待更多的好友来测试呦~</span>
  }
}

const FriendResult = (props) => {
  const { reloadFlag, participated, topFourTypes, friendTestResultListInfoList, goBack, goBackToQuestions } = props;
  const [visible, setVisible] = useState(false);

  return (
    <div style={{ backgroundColor: '#ab282e', padding: '10px' }}>
      <img src={friendrst} alt="" />
      {/* 判断答题状态展示邀请好友数据还是 立即答题按钮 这个true等下改成answerState  */}
      {!participated ? (
        <><div className='ads4rlb'>
          <h3>你邀请的好友测试结果</h3>
          <p>哎鸭！你还没有参与答题，也没有邀请好友参与哟~</p>
          <button onClick={goBackToQuestions} className='overlayButtonInvite' >想知道你和好友们的<br />性格默契匹配度吗？<br /><br />参与答题<br />邀请好友</button>
          <hr /><Ads4Rlb />
        </div>
        </>) : (
        <><div className='ivtContainer'>
          <h3>你邀请的好友测试结果</h3>
          <ul ><h4>谁是我的正缘？</h4>
            <UserList type="destinedPar" topFourTypes={topFourTypes} friendTestResultListInfoList={friendTestResultListInfoList} />
            <hr />
          </ul>
          <ul><h4>谁是我的贵人？</h4>
            < UserList type="benefactor" topFourTypes={topFourTypes} friendTestResultListInfoList={friendTestResultListInfoList} />
            <hr /></ul>
          <ul><h4>谁是旺我的人？</h4>
            < UserList type="luckyCharm" topFourTypes={topFourTypes} friendTestResultListInfoList={friendTestResultListInfoList} />
            <hr /></ul>
          <ul><h4>谁是我的孽缘？</h4>
            < UserList type="cursedConnection" topFourTypes={topFourTypes} friendTestResultListInfoList={friendTestResultListInfoList} />
            <hr /></ul>
          <Ads4Rlb />
        </div>
        </>)}
      <img style={{ marginTop: 15 }} src={friendrst2} alt="" />
      {/* <Mask opacity='thick' visible={visible} onMaskClick={() => setVisible(false)}>
        <img onClick={() => setVisible(false)} src={FXT} style={{ position: 'absolute', right: 0, top: 0, width: 200 }} />
      </Mask> */}
      {
        topFourTypes && reloadFlag === 2 && <div style={{ position: 'fixed', bottom: 10, left: 0, display: 'flex', alignItems: 'center', justifyContent: 'space-around', width: '100%' }}>
        <img style={{ width: '90%' }} src={FHCS} alt="" onClick={goBack} />
      </div>
      }
    </div>
  );
};

export default FriendResult;
